<script>
import Endpoints from '../../../../components/common/Endpoints';
import Common from '../../../../components/common/Common';
import Request from '../../../../components/common/Request';
import { mapActions } from 'vuex'

export default {
    init: (payload) => {
        console.log(payload.order);
    },
    methods:{
        selectItem: function(item){
            this.data = item; 
            this.orderSelected = item;
        },
        checkClose: function(item){
            return (item.statusOrder.toUpperCase() != 'CLOSED' && item.statusOrder.toUpperCase() != 'PAID' && item.statusOrder.toUpperCase() != 'REJECTED' )
            return null;
        },
        getTrucksByUser: async function(){
            this.trucks = [];
            if(this.systemUser && this.systemUser.length > 0){
                await Request.do(this, 'POST', Request.getDefaultHeader(this),  {truckDriver: this.systemUser, status:'ACTIVE'}, `${Endpoints.trucks.listByType}`,
                (response)=>{//SUCCESS CALLBACK
                    this.trucks = response.results; 
                },
                (error)=>{//ERROR CALLBACK
                    this.titleToast = this.$t('str.msg.toast.advice');
                    this.messageToast = this.$t('str.msg.error.generic');
                    let res = error.response;
                    if (res){
                        this.messageIdToast = res;
                    }
                    $('#toast').modal('show');
                });
            }

        },
        confirmArchive: function(item){
            this.titleToast = this.$t("string.msg.confirm");
            this.messageToast = this.$t("response.close.order.confirmation");
            this.cancelText = this.$t("string.msg.cancel");
            this.yesText = this.$t("string.msg.yes");
            this.orderSelected = item;

             setTimeout(async function(){
                this.$('#confirmationCloseCertifie').modal('show');
                }, 100);
        },
        // getLocation: async (payload) => {
        //     console.log("INICIO");
        //     console.log(this.locationOrder);
        //     if(payload.order && payload.order.longitude!=null && payload.order.longitude!=null){
        //         setTimeout(async function(){
        //         let response = (await Request.do(payload, 'POST', Request.getDefaultHeader(payload),`${Endpoints.location.geolocation}${payload.order.latitude},${payload.order.longitude}&KEY=${payload.Confs.KEY_MAPS}`));
        //         if (response && response.status==200){
        //              this.locationOrder = response.results;
        //              console.log(this.locationOrder);
        //         }
        //         }, 100);
        //     }
       

        // },
        archive: function(response, justifyClose){
            if (response==1){
                $('#spinner').modal('toggle');
                this.errors = [];
                this.messageIdToast = null;
                let state = this;
                
                Request.do(this, 'POST', Request.getDefaultHeader(this), {justifyClose: justifyClose} , `${Endpoints.orders.close}${this.orderSelected._id}`,
                    (companyResponse)=>{//SUCCESS CALLBACK

                        $('#spinner').modal('toggle');
                        $('#confirmationCloseCertifie').modal('toggle');
                    },
                    (error)=>{//ERROR CALLBACK
                        this.$('#spinner').modal('toggle');
                        let res = error.response;
                        if (res && res.status){
                            this.titleToast = this.$t("string.msg.warning");
                            if (res.data.messageId === 'response.msg.error.empty.fields'){
                                let fields = "";
                                res.data.errors.forEach(function (value) {
                                    fields += state.$t(value.id)+";<br/>";
                                });
                                this.titleToast = this.$t(res.data.messageId);
                                this.messageToast = this.$t(fields);
                            }else{
                                this.messageToast = this.$t(res.data.messageId);
                                this.messageIdToast = res.data.messageId;
                            }

                            this.$('#toast').modal('show');
                        }
                        // console.log(JSON.stringify(error));
                });
            }
            else{$('#confirmationCloseCertifie').modal('toggle');}
        },
        camelize: Common.camelize,
        toUpperCase: Common.toUpperCase,
    }
}
</script>
